var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classroom-view"},[_c('section',[_c('eg-b-row',[_c('eg-b-col',[_c('StartGradingContainer',{staticClass:"imports-google-classroom-view"},[_c('eg-b-row',{staticClass:"justify-content-center align-items-center"},[_c('eg-b-col',{attrs:{"cols":"12"}},[(!_vm.serviceAccount.id || !_vm.serviceAccount.isGCAvailable)?_c('import-connect',{on:{"input":_vm.updateServiceAccount}}):_vm._e(),(
                  _vm.serviceAccount &&
                  _vm.serviceAccount.id &&
                  _vm.serviceAccount.isGCAvailable
                )?_c('import-wizard',{attrs:{"platform":"google"}}):_vm._e()],1)],1)],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }